module.exports = __webpack_public_path__ + "img/teamone.117396a6.png";